import { signOut } from "actions/user";
import SageScreen from "kit/SageScreen";
import React from "react";
import { useDispatch } from "react-redux";
import SettingsEmailRow from "./settings/SettingsEmailRow";
import SettingsUsernameRow from "./settings/SettingsUsernameRow";

const Settings: React.FC = () => {
    const dispatch = useDispatch();

    const handleSignOut = React.useCallback(() => {
        dispatch(signOut());
    }, [dispatch]);

    return (
        <>
            <div className="modal fade" id="signOutModal" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Are you sure?</h5>
                            <button
                                type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            Are you sure that you want to sign out?
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-dismiss="modal"
                            >
                                Cancel
                            </button>
                            <button
                                id="sign-out"
                                type="button"
                                className="btn btn-danger"
                                data-dismiss="modal"
                                onClick={handleSignOut}
                            >
                                Sign Out
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <SageScreen>
                <h2>Settings</h2>
                <SettingsUsernameRow />
                <SettingsEmailRow />
                <button
                    data-toggle="modal"
                    data-target="#signOutModal"
                    className="btn btn-danger"
                >
                    Sign Out
                </button>
            </SageScreen>
        </>
    );
};

export default Settings;
